module.exports = __webpack_public_path__ + "static/dosing-graphic-keytruda-desktop_rev1-5ec72844ea01a02b4ce8ec5a56fc47a2.png";